/**
 * Concat baseUrl and url in a "/" safe manner
 */
export function buildUrl(baseUrl: string, url: string) {
  if (!baseUrl) {
    baseUrl = '/';
  }
  if (baseUrl[baseUrl.length - 1] !== '/' && url[0] !== '/') {
    return `${baseUrl}/${url}`;
  }
  if (baseUrl[baseUrl.length - 1] === '/' && url[0] === '/') {
    return `${baseUrl}${url.substring(1)}`;
  }
  return `${baseUrl}${url}`;
}

/**
 * Util function to format currency
 */
export function formatCurrency(value: string | number) {
  return `$${value}`;
}

export const getStarRating = c =>
  c.ratings && c.ratings.star_rating >= 0 ? c.ratings.star_rating : undefined;

export const getRatingsNumber = c =>
  c.ratings && c.ratings.hired_recommendations >= 0 ? c.ratings.hired_recommendations : undefined;
